
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative flex items-center justify-center overflow-hidden pt-24" style={{ minHeight: '100vh' }}>
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/f71f33d513c6f79c856047afbe08c8da.jpg"
          alt="町家珈琲の温かい店内"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-4xl w-full py-16">
        <div className="mb-6">
          <span className="inline-flex items-center px-4 py-2 bg-amber-800/20 backdrop-blur-sm border border-amber-300/30 rounded-full text-amber-100 text-sm font-medium mb-4">
            <i className="ri-leaf-line mr-2"></i>
            創業30年の伝統
          </span>
        </div>

        <div className="mb-8">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-4 leading-tight" style={{ fontFamily: 'Noto Serif JP, serif' }}>
            町家珈琲
          </h1>
          <h2 className="text-2xl md:text-3xl text-amber-200 font-medium mb-6" style={{ fontFamily: 'Noto Serif JP, serif' }}>
            伝統と香りの空間
          </h2>
          <p className="text-lg md:text-xl text-gray-200 leading-relaxed max-w-2xl mx-auto">
            木の温もりに包まれた心安らぐ一杯を<br />
            自家焙煎の香り高いコーヒーと季節の味わいをお楽しみください
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-16">
          <Button 
            size="lg"
            onClick={() => scrollToSection('menu')}
            className="min-w-[180px]"
          >
            <i className="ri-book-open-line mr-2"></i>
            メニューを見る
          </Button>
          <Button 
            variant="outline"
            size="lg"
            onClick={() => scrollToSection('contact')}
            className="min-w-[180px] bg-white/10 backdrop-blur-sm border-white/30 text-white hover:bg-white hover:text-amber-800"
          >
            <i className="ri-map-pin-line mr-2"></i>
            店舗情報
          </Button>
        </div>

        <div className="mt-8">
          <img
            src="https://readdy.ai/api/search-image?query=Japanese%20coffee%20shop%20wooden%20counter%20with%20traditional%20coffee%20brewing%20equipment%2C%20ceramic%20cups%2C%20coffee%20beans%2C%20warm%20wooden%20texture%2C%20traditional%20Japanese%20interior%20design%20elements%2C%20soft%20natural%20lighting%2C%20cozy%20atmosphere&width=800&height=400&seq=machiya-counter&orientation=landscape"
            alt="木製カウンターとコーヒー器具"
            className="w-full max-w-xl mx-auto rounded-2xl shadow-2xl"
          />
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2">
        <div className="animate-bounce">
          <i className="ri-arrow-down-line text-white text-2xl"></i>
        </div>
      </div>
    </section>
  );
}
